import { useEffect, useState } from "react";
import API from "../services/api";
import "../styles/dashboard.css";

export default function CEOApproval() {
  const [claims, setClaims] = useState([]);
  const [managers, setManagers] = useState([]);
  const [selectedManager, setSelectedManager] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const format = (num) => Number(num || 0).toLocaleString();

  // ================= LOAD CLAIMS =================
  const loadClaims = async (managerId = "") => {
    try {
      setError("");
      setLoading(true);

      const url = `/ceo/claims${
        managerId ? `?manager_id=${managerId}` : ""
      }`;

      const res = await API.get(url);
      setClaims(res.data || []);
    } catch (err) {
      console.log(err);
      setError("Failed to load claims");
    } finally {
      setLoading(false);
    }
  };

  // ================= LOAD MANAGERS =================
  const loadManagers = async () => {
    try {
      const res = await API.get("/ceo/managers");
      setManagers(res.data || []);
    } catch (err) {
      console.log(err);
    }
  };

  // ================= DECISION =================
  const handleDecision = async (id, decision) => {
    try {
      setLoading(true);

      await API.post(`/ceo/decision/${id}`, { decision });

      // refresh claims
      await loadClaims(selectedManager);

    } catch (err) {
      console.log(err);
      alert("Action failed");
    } finally {
      setLoading(false);
    }
  };

  // ================= INIT =================
  useEffect(() => {
    loadManagers();
    loadClaims();
  }, []);

  return (
    <div className="dashboard-container">

      <h2 className="dashboard-heading">Final Approval</h2>

      {/* ================= FILTER ================= */}
      <div className="top-bar">
        <select
          className="input"
          value={selectedManager}
          onChange={(e) => {
            const val = e.target.value;
            setSelectedManager(val);
            loadClaims(val);
          }}
        >
          <option value="">All Managers</option>

          {managers.map((m) => (
            <option key={m.id} value={m.id}>
              {m.name}
            </option>
          ))}
        </select>
      </div>

      {/* ================= STATES ================= */}
      {loading && <p style={{ marginTop: 10 }}>Processing...</p>}

      {error && <p style={{ color: "red" }}>{error}</p>}

      {/* ================= TABLE ================= */}
      <div className="table-card">
        <table className="table">
          <thead>
            <tr>
              <th>Salesman</th>
              <th>Dealer</th>
              <th>Customer</th>
              <th>Mobile</th>
              <th>City</th>
              <th>QR</th>
              <th>Date</th>
              <th>Amount</th>
              <th>Manager</th>
              <th>Final</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {claims.length === 0 ? (
              <tr>
                <td colSpan="11" style={{ textAlign: "center" }}>
                  No claims found
                </td>
              </tr>
            ) : (
              claims.map((c) => (
                <tr key={c.id}>
                  <td>{c.salesman_name}</td>
                  <td>{c.dealer_name}</td>
                  <td>{c.customer_name}</td>
                  <td>{c.customer_mobile}</td>
                  <td>{c.city}</td>
                  <td>{c.qr_value}</td>
                  <td>
                    {new Date(c.created_at).toLocaleDateString()}
                  </td>
                  <td>
                    <b>Rs {format(c.claim_amount)}</b>
                  </td>

                  {/* MANAGER */}
                  <td>
                    <span className={`badge badge-${c.manager_status}`}>
                      {c.manager_status}
                    </span>
                  </td>

                  {/* FINAL */}
                  <td>
                    <span className={`badge badge-${c.ceo_status}`}>
                      {c.ceo_status}
                    </span>
                  </td>

                  {/* ACTION */}
                  <td>
                    {c.ceo_status === "pending" ? (
                      <>
                        <button
                          className="btn btn-approve"
                          disabled={loading}
                          onClick={() =>
                            handleDecision(c.id, "approved")
                          }
                        >
                          ✔
                        </button>

                        <button
                          className="btn btn-reject"
                          disabled={loading}
                          onClick={() =>
                            handleDecision(c.id, "rejected")
                          }
                        >
                          ✖
                        </button>
                      </>
                    ) : (
                      <span style={{ color: "gray" }}>
                        Locked
                      </span>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

    </div>
  );
}